import {
  Box,
  Center,
  Image,
  Skeleton,
  Stack,
  usePrefersReducedMotion,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

import ai_for_everyone from "./images/ai_for_everyone.webp";
import haus_und_hof_kiel from "./images/haus_und_hof_kiel.webp";
import hr_services from "./images/hr_services.webp";
import hunde_fragen from "./images/hunde_fragen.webp";
import jd_it_consulting_kiel from "./images/jd_it_consulting_kiel.webp";
import kroll_bauausführungen from "./images/kroll_bauausführungen.webp";
import lernhilfe_club_kiel from "./images/lernhilfe_club_kiel.webp";
import moebius_architekten from "./images/moebius_architekten.webp";
import target_ki from "./images/target_ki.webp";
import tiefbau_wernecke from "./images/tiefbau_wernecke.webp";
import niro_schmidt_laboe from "./images/niro_schmidt_laboe.webp";

import charlys_welt from "./images/charlys_welt.webp";
import picobello from "./images/picobello.webp";
import colditz_immobilien_kiel from "./images/colditz_immobilien_kiel.webp";

// import Marquee from "react-marquee-slider"; // Removed due to paused attribute warning
import { HeadLine } from "../HeadLine";
import { ActionButton } from "../ActionButton";
import { useContaxt } from "../../context/Context";

const referenceImages = [
  ai_for_everyone,
  haus_und_hof_kiel,
  hr_services,
  hunde_fragen,
  charlys_welt,
  colditz_immobilien_kiel,
  jd_it_consulting_kiel,
  kroll_bauausführungen,
  lernhilfe_club_kiel,
  picobello,
  moebius_architekten,
  target_ki,
  tiefbau_wernecke,
  niro_schmidt_laboe,
];

export function ReferenceSlider() {
  const prefersReducedMotion = usePrefersReducedMotion();
  const { isMobile } = useContaxt();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function preloadImages() {
      await Promise.allSettled(
        referenceImages.map(
          (src) =>
            new Promise((resolve, reject) => {
              const img = new window.Image();
              img.onload = resolve;
              img.onerror = reject;
              img.src = src;
            })
        )
      );

      if (!cancelled) {
        setIsReady(true);
      }
    }

    preloadImages();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Stack spacing={"30px"}>
      <HeadLine as="h2" text="Diese Unternehmen vertrauen auf uns..." />
      <Box
        position="relative"
        h="100px"
        display="flex"
        alignItems="center"
        sx={{
          ".swiper": {
            width: "100%",
            height: "100%",
            pointerEvents: "none",
          },
          ".swiper-wrapper": {
            alignItems: "center",
            transitionTimingFunction: "linear !important",
          },
          ".swiper-slide": {
            width: "auto",
          },
        }}
      >
        {!isReady ? (
          <Box w="100%" display="flex" gap={10} px={10} overflow="hidden">
            {Array.from({ length: 6 }).map((_, index) => (
              <Skeleton
                key={`reference-skeleton-${index}`}
                h={isMobile ? "50px" : "75px"}
                w="140px"
              />
            ))}
          </Box>
        ) : (
          <Marquee
            play={!prefersReducedMotion}
            pauseOnHover={false}
            pauseOnClick={false}
            gradient={false}
            speed={isMobile ? 55 : 45}
            style={{ width: "100%", height: "100%" }}
          >
            {referenceImages.map((reference, index) => (
              <Center key={`references-${index}`} h="100%" mr={"40px"}>
                <Image
                  alt={`reference-${index}`}
                  w="auto"
                  h={isMobile ? "50px" : "75px"}
                  src={reference}
                  objectFit="contain"
                  draggable={false}
                />
              </Center>
            ))}
          </Marquee>
        )}
      </Box>
      <Center>
        <ActionButton mt={"32px"} h={"70px"} fontSize={"16px"} />
      </Center>
    </Stack>
  );
}
